var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable complexity */
import React, { forwardRef, useState, useEffect } from 'react';
import cx from 'classnames';
import { Grid, Icon, Container, Typography } from '../../';
import * as S from './styles';
export var Card = forwardRef(function Card(_a, ref) {
    var children = _a.children, className = _a.className, clickable = _a.clickable, spacing = _a.spacing, padding = _a.padding, heading = _a.heading, icon = _a.icon, startAdornment = _a.startAdornment, endAdornment = _a.endAdornment, open = _a.open, disabled = _a.disabled, inverted = _a.inverted, style = _a.style, rest = __rest(_a, ["children", "className", "clickable", "spacing", "padding", "heading", "icon", "startAdornment", "endAdornment", "open", "disabled", "inverted", "style"]);
    var _b = useState(open), isOpen = _b[0], setIsOpen = _b[1];
    useEffect(function () {
        setIsOpen(open);
    }, [open]);
    var fontColor = inverted ? 'white' : 'primary';
    var baseTypographySettings = {
        size: 'medium',
        weight: 'regular',
        align: 'justify',
        color: fontColor
    };
    var clickableResolved = clickable && !disabled && (startAdornment || endAdornment);
    var invertedClassName = inverted ? 'inverted-card' : false;
    var clickableClassName = clickableResolved && 'clickable';
    var rootClass = cx(className, invertedClassName, clickableClassName);
    var renderIcon = !isOpen ? (icon ? (React.createElement(Container, { onClick: function () { return setIsOpen(!isOpen); }, flex: true, style: { cursor: 'pointer' } }, icon)) : (React.createElement(Icon, { name: 'info', as: 'link', size: 'small', onClick: function () { return setIsOpen(!isOpen); }, style: { display: 'flex' }, color: 'black' }))) : (React.createElement(Icon, { name: 'cross', as: 'link', size: 'small', onClick: function () { return setIsOpen(!isOpen); }, style: { display: 'flex' }, color: inverted ? 'white' : 'black' }));
    var renderHeader = (React.createElement(Container, null,
        React.createElement(Grid, { spacing: 'small', wrap: 'nowrap', justifyContent: 'space-between', alignItems: 'center' },
            React.createElement(Grid.Item, { style: { flex: 1 } },
                React.createElement(Typography, { as: 'span', variant: 'heading', size: 'small', weight: 'semibold', color: fontColor }, heading)),
            !disabled && (startAdornment || endAdornment) && React.createElement(Grid.Item, null, renderIcon))));
    var renderStartAdornment = (React.createElement(Container, { bottom: children || endAdornment ? spacing : undefined, top: spacing }, typeof startAdornment === 'string' ? (React.createElement(Typography, __assign({}, baseTypographySettings), startAdornment)) : (startAdornment)));
    var renderChildren = (React.createElement(Container, { top: spacing }, typeof children === 'string' ? React.createElement(Typography, __assign({}, baseTypographySettings), children) : children));
    var renderEndAdornment = (React.createElement(Container, { top: children || endAdornment ? spacing : undefined }, typeof endAdornment === 'string' ? (React.createElement(Typography, __assign({}, baseTypographySettings), endAdornment)) : (endAdornment)));
    return (React.createElement(S.CardPaper, __assign({ ref: ref, className: rootClass, style: style, onClick: function () { return clickableResolved && setIsOpen(!isOpen); } }, rest),
        React.createElement(Container, { padded: padding },
            renderHeader,
            isOpen && startAdornment && renderStartAdornment,
            children && renderChildren,
            isOpen && endAdornment && renderEndAdornment)));
});
Card.defaultProps = {
    inverted: false,
    clickable: true,
    disabled: false,
    padding: 'medium',
    spacing: 'xsmall'
};
Card.displayName = 'Card';
export default Card;
//# sourceMappingURL=Card.js.map